import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Import global Tailwind CSS
import App from './App.jsx'; // Import the main component

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
